import { Cpu } from "lucide-react";
import { Link } from "react-router-dom";
import { BUSINESS } from "../lib/site";
import { SERVICE_PAGE_LIST } from "../lib/services-data";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 py-16 bg-[#0A0A0A]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src="/logo.png" alt="Tombs Electronic Repair" className="h-10 w-auto object-contain" />
            </Link>
            <p className="text-zinc-400 text-sm leading-relaxed max-w-xs">
              Honest, transparent console &amp; PC repair out of Susquehanna, Pennsylvania.
            </p>
          </div>

          <div>
            <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-4">Repairs</div>
            <ul className="space-y-2 text-sm">
              {SERVICE_PAGE_LIST.map((p) => (
                <li key={p.slug}>
                  <Link
                    to={`/repair/${p.slug}`}
                    className="text-zinc-300 hover:text-white"
                    data-testid={`footer-service-${p.slug}`}
                  >
                    {p.short} repair
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-4">Site</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-zinc-300 hover:text-white">Home</Link></li>
              <li><a href="/#services" className="text-zinc-300 hover:text-white">Services</a></li>
              <li><a href="/#pricing" className="text-zinc-300 hover:text-white">Pricing</a></li>
              <li><a href="/#process" className="text-zinc-300 hover:text-white">Process</a></li>
              <li><a href="/#reviews" className="text-zinc-300 hover:text-white">Reviews</a></li>
              <li><a href="/#track" className="text-zinc-300 hover:text-white">Track repair</a></li>
              <li><a href="/#booking" className="text-zinc-300 hover:text-white">Book repair</a></li>
              <li>
                <Link to="/admin" className="text-zinc-500 hover:text-white text-xs" data-testid="footer-admin-link">
                  Admin
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-4">Reach me</div>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li>{BUSINESS.address}</li>
              <li>
                <a href={BUSINESS.phoneHref} className="hover:text-white">{BUSINESS.phone}</a>
              </li>
              <li>
                <a href={BUSINESS.emailHref} className="hover:text-white">{BUSINESS.email}</a>
              </li>
              <li className="text-zinc-500 text-xs pt-2">Mon–Fri: Email & Phone Only · Sat night · All day Sunday</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-900 pt-8 flex flex-col sm:flex-row justify-between gap-4 font-mono text-[11px] tracking-[0.15em] uppercase text-zinc-600">
          <div>© {new Date().getFullYear()} {BUSINESS.llc}. All rights reserved.</div>
          <div>Built in PA · Run by a real human</div>
        </div>
      </div>
    </footer>
  );
}
